<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Laura, thank you for being my grammar Nazi. You made critiquing my terrible grammar fun. With a bottle of wine and a listening ear, you always supported me, and I am grateful. Thank you for being my friend and I love you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?827fca3a